
// src/pages/Auth/Login.js
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Alert } from 'react-bootstrap';
import LoginForm from '../../components/Auth/LoginForm';

const Login = () => {
    const location = useLocation();
    const isRegistered = new URLSearchParams(location.search).get('registered') === 'true';

    return (
        <div className="auth-page">
            <div className="auth-card">
                <div className="auth-header">
                    <div className="auth-logo">
                        <div className="avatar-circle2 mx-auto">
                            <i className="fas fa-display"></i>
                        </div>
                    </div>
                    <h1>WP Monitor</h1>
                    <p className="text-muted">Přihlaste se ke svému účtu</p>
                </div>
                <div className="auth-body">
                    {isRegistered && (
                        <Alert variant="success" className="mb-4">
                            Registrace proběhla úspěšně! Nyní se můžete přihlásit.
                        </Alert>
                    )}
                    <LoginForm />
                </div>
                <div className="auth-footer">
                    <p className="mb-0">Nemáte účet? <Link to="/register">Registrujte se</Link></p>
                </div>
            </div>
        </div>
    );
};

export default Login;